<div [class]="className()">
  <mat-icon class="card-icon">{{ resolvedIcon() }}</mat-icon>

  @if (variant() === 'NOTICE') {
    <span class="card-text">{{ title() ?? subtitle() }}</span>
  } @else {
    <div class="card-body">
      @if (title()) {
        <p class="card-title">{{ title() }}</p>
      } @else {
        <ng-content select="[title]"></ng-content>
      }
      @if (subtitle()) {
        <p class="card-subtitle">{{ subtitle() }}</p>
      } @else {
        <ng-content select="[subtitle]"></ng-content>
      }
    </div>
  }
  @if (hasContent()) {
    <div class="content">
      <ng-content></ng-content>
    </div>
  }
  @if (buttonText() || link()) {
    <div class="actions">
      @if (buttonText()) {
        <button mat-raised-button class="action-btn" (click)="onButtonClick()">{{ buttonText() }}</button>
      }
      @if (link()) {
        <a mat-raised-button [routerLink]="link()" class="learn-more-btn">
          <mat-icon>help</mat-icon>
          Learn more
        </a>
      }
    </div>
  }
</div>
